export function createAccordian(selector, options = {}) {
    
  options = jQuery.extend(defaultOptions(), options);

  var toggleDoneCallback = typeof options["doneCallback"] !== "undefined" ? options["doneCallback" ] : null;
  
  var slideToggleOptions = {};
  if ( toggleDoneCallback ){
    slideToggleOptions.done = toggleDoneCallback;
  }
  
  const container = $(selector);
  const children = container.children();

  children.each(function(index, child) {
    // if we're on an odd child, skip over
    if (index % 2 == 1 || index === children.length - 1) {
      return;
    }

    // set up the header and body
    var header = $(child);
    var body = $(children[index + 1]);
    header.addClass("clickable");

    header.click(function(e) {
      // mark header as open then open and call toggle callback
      header.attr("data-accordian-open", !isOpen(header));
      body.slideToggle( slideToggleOptions );
      options.toggleCallback(isOpen(header), header, body);

      // if appropriate, hide all other open headers
      if (options.hideOthersOnToggle) {
        children.each(function(subIndex, subChild) {
          if (
            subIndex % 2 == 1 ||
            index === children.length - 1 ||
            subIndex === index
          ) {
            return;
          }

          var subHeader = $(subChild);
          var subIsOpen = isOpen(subHeader);
          if (!subIsOpen) {
            return;
          }
          subHeader.attr("data-accordian-open", false);
          var subBody = $(children[subIndex + 1]);
          subBody.slideUp();
          options.toggleCallback(false, subHeader, subBody);
        });
      }
    });

    if (header.attr("data-accordian-start-open") === "true"){
      header.click();
    }
  });
}

export function openAccordian(selector, index) {
  const container = $(selector);
  const children = container.children();
  const header = $(children[index * 2]);
  if (isOpen(header)){
    return;
  }
  header.click();
  return;
}

function isOpen(header) {
  return $(header).attr("data-accordian-open") === "true";
}

function defaultOptions() {
  return {
    toggleCallback: function(open, header, body) {},
    hideOthersOnToggle: true
  };
}
